export const ALIAS_COLUMNS = [
	{ heading: 'Alias type', value: 'aliasCodeDescription' },
	{ heading: 'Description', value: 'aliasDetails' },
	{ heading: 'Primary', value: 'primaryAlias', type: 'boolean' }
];
